<template>
    <q-dialog v-model="modal" persistent>
        <q-card>
            <q-card-section class="row items-center q-pb-none">
                <q-card-section>
                    <div class="text-h6"><slot name="title"></slot></div>
                </q-card-section>
                <div class="q-space"></div>
                <q-btn icon="close" flat round dense v-close-popup />
            </q-card-section>

            <q-card-section>
                <slot name="content"></slot>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>
    export default {
        name: "Info",
        data () {
            return {
                modal: false
            }
        },
        methods: {
            show() {
                this.modal = true;
            },
        }
    }
</script>
